import { AUTH_STRATEGY_CONFIG_TOKEN, AUTH_STRATEGY_TOKEN } from './auth-strategy-provider';
import { AuthStrategyType } from './auth-strategy-definition.interface';
import { DevToolsRegistry } from '../dev-tools/dev-tools.registry';
import * as i0 from "@angular/core";
import * as i1 from "../dev-tools/dev-tools.registry";
export let AuthStrategiesService = /*#__PURE__*/(() => {
  class AuthStrategiesService {
    constructor(devTools, strategies, configs) {
      this.devTools = devTools;
      if (!configs) configs = [];
      if (!strategies) strategies = [];
      this.strategies = strategies.map(s => {
        const config = configs.find(c => c.name === s.name);
        return {
          ...s,
          enabled: !!config,
          config
        };
      });
      devTools.exposeDebugFunction(['Auth Strategies'], () => {
        const list = this.strategies.map(s => {
          return {
            name: s.name,
            enabled: s.enabled,
            strategyTypes: this.getStrategyTypes(s)
          };
        });
        return [{
          reminder: 'Only enabled strategies will be used/displayed in UI! Update provideAuthStrategyConfig() according to your requirements!'
        }, ...list];
      });
    }
    getStrategiesOfType(type) {
      const authenticationStrategies = this.strategies.reduce((coll, strat) => {
        if (!strat.enabled) return coll;
        const supportsType = this.getStrategyTypes(strat).includes(type);
        if (supportsType) coll.push(strat[type]);
        return coll;
      }, []);
      return authenticationStrategies;
    }
    getStrategyTypes(s) {
      const types = [];
      if (s.authenticate) types.push(AuthStrategyType.authenticate);
      if (s.register) types.push(AuthStrategyType.register);
      return types;
    }
    static {
      this.ɵfac = function AuthStrategiesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AuthStrategiesService)(i0.ɵɵinject(i1.DevToolsRegistry), i0.ɵɵinject(AUTH_STRATEGY_TOKEN, 8), i0.ɵɵinject(AUTH_STRATEGY_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AuthStrategiesService,
        factory: AuthStrategiesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AuthStrategiesService;
})();